/**
 * Entry point for Guide page JS bundle
 * # ⛓️ CURSOR_ANCHOR:guide:js
 * Includes: jQuery, Theme logic, and Guide-specific logic
 */

// Import theme modules (they populate window object for backward compatibility)
// Theme module (loaded sequentially)
import '../search/theme/constants.js';
import '../search/theme/storage.js';
import '../search/theme/detection.js';
import '../search/theme/application.js';
import '../search/theme/toggle.js';
import '../search/theme/ui.js';
import '../search/theme/events.js';
import '../search/theme/init.js';
import '../search/theme.js';

// Theme toggle is available via theme.js (window.toggleTheme)
// The delegated event handler from events.js should handle clicks on #logo-cell
// But we ensure it's set for compatibility with inline onclick handlers
if (!window.toggleTheme) {
    window.toggleTheme = function() {
        if (window.THEME && window.THEME.toggle) {
            window.THEME.toggle();
        } else if (window.THEME_TOGGLE && window.THEME_TOGGLE.toggle) {
            window.THEME_TOGGLE.toggle();
        }
    };
}

$(document).ready(function() {

    const navLinks = $('.guide-nav a');
    const sections = $('.guide-section');
    const indicator = $('.nav-indicator');
    
    /**
     * Плавное перемещение индикатора (линии) к активному пункту
     */
    function moveIndicator($activeLink) {
        if (!$activeLink || !$activeLink.length) return;
        
        const linkPos = $activeLink.position();
        const linkHeight = $activeLink.outerHeight();
        
        indicator.css({
            'top': linkPos.top + (linkHeight * 0.2) + 'px',
            'height': (linkHeight * 0.6) + 'px',
            'opacity': 1
        });
    }

    /**
     * Определение активного раздела при скролле (ScrollSpy)
     * Используем более надежный метод по координатам заголовков
     */
    function updateActiveNav() {
        const scrollPos = $(window).scrollTop();
        const viewportHeight = $(window).height();
        let currentSectionId = '';

        // Порог срабатывания - 1/3 от верха экрана
        const triggerPoint = scrollPos + 150;

        // Идем с конца, чтобы найти самый нижний раздел, заголовок которого мы пересекли
        for (let i = sections.length - 1; i >= 0; i--) {
            const section = $(sections[i]);
            if (section.offset().top <= triggerPoint) {
                currentSectionId = section.attr('id');
                break;
            }
        }

        // Если мы в самом верху страницы
        if (scrollPos < 100) {
            currentSectionId = sections.first().attr('id');
        }

        if (currentSectionId) {
            const activeLink = navLinks.filter('[href="#' + currentSectionId + '"]');
            if (!activeLink.hasClass('active')) {
                navLinks.removeClass('active');
                activeLink.addClass('active');
                moveIndicator(activeLink);
            }
        }
    }

    // Обработка скролла с оптимизацией производительности
    let isScrolling = false;
    $(window).on('scroll resize', function() {
        if (!isScrolling) {
            window.requestAnimationFrame(() => {
                updateActiveNav();
                isScrolling = false;
            });
            isScrolling = true;
        }
    });
    
    // Плавный скролл по клику
    navLinks.on('click', function(e) {
        e.preventDefault();
        const target = $(this).attr('href');
        const $target = $(target);
        
        if ($target.length) {
            const targetPos = $target.offset().top - 60;
            
            $('html, body').stop().animate({
                scrollTop: targetPos
            }, 800, 'swing', function() {
                history.replaceState(null, null, target);
            });
        }
    });
    
    // Начальная установка
    setTimeout(() => {
        updateActiveNav();
        const initialActive = navLinks.filter('.active');
        if (initialActive.length) moveIndicator(initialActive);
    }, 200);

    function collectEmailParts($element) {
        if (!$element || !$element.length) {
            return { user: null, domain: null };
        }

        const explicitUser = $element.data('user');
        const explicitDomain = $element.data('domain');
        if (explicitUser && explicitDomain) {
            return { user: explicitUser, domain: explicitDomain };
        }

        const $locator = $element.closest('[data-user][data-domain]');
        if ($locator.length) {
            return { user: $locator.data('user'), domain: $locator.data('domain') };
        }

        return { user: null, domain: null };
    }

    function buildEmailAddress(user, domain) {
        if (!user || !domain) {
            return null;
        }

        return `${user}@${domain}`;
    }

    function fallbackClipboardWrite(text) {
        return new Promise((resolve, reject) => {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);

            textarea.select();
            textarea.setSelectionRange(0, textarea.value.length);

            let success = false;
            try {
                success = document.execCommand('copy');
            } catch (error) {
                success = false;
            }

            document.body.removeChild(textarea);

            if (success) {
                resolve();
            } else {
                reject(new Error('execCommand copy failed'));
            }
        });
    }

    function copyTextToClipboard(text) {
        if (!text) {
            return Promise.reject(new Error('No text provided'));
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(text);
        }

        return fallbackClipboardWrite(text);
    }

    function copyEmailAndReport($element, email) {
        if (!email) {
            return Promise.reject(new Error('No email to copy'));
        }

        const $wrapper = $element.closest('.contact-email-wrapper');
        const successMessage = $wrapper.data('copy-success') || 'Email copied to clipboard';
        const errorMessage = $wrapper.data('copy-error') || 'Unable to copy email address';

        return copyTextToClipboard(email)
            .then(() => showCopyFeedback($element, successMessage))
            .catch(() => showCopyFeedback($element, errorMessage));
    }

    function showCopyFeedback($element, message) {
        if (!message) {
            return;
        }

        const $wrapper = $element.closest('.contact-email-wrapper');
        const $feedback = $wrapper.find('.email-copy-feedback');
        if (!$feedback.length) {
            return;
        }

        $feedback.text(message).addClass('visible');
        if ($wrapper.data('copyFeedbackTimer')) {
            clearTimeout($wrapper.data('copyFeedbackTimer'));
        }

        const timer = setTimeout(() => {
            $feedback.removeClass('visible');
        }, 2200);

        $wrapper.data('copyFeedbackTimer', timer);
    }

    function hydrateEmailSpans() {
        $('.email-antispam').each(function() {
            const $span = $(this);
            const { user, domain } = collectEmailParts($span);
            const email = buildEmailAddress(user, domain);

            if (!email) {
                return;
            }

            $span.text(email);
            $span.attr('aria-label', email);
        });
    }

    /**
     * Обработка клика по защищенному email
     */
    window.handleEmailClick = function(e, element) {
        e.preventDefault();
        const $element = $(element);
        const { user, domain } = collectEmailParts($element);
        const email = buildEmailAddress(user, domain);
        if (!email) {
            return;
        }

        copyEmailAndReport($element, email);
        window.location.href = 'mailto:' + email;
    };

    window.handleEmailCopy = function(e, element) {
        e.preventDefault();

        const $element = $(element);
        const { user, domain } = collectEmailParts($element);
        const email = buildEmailAddress(user, domain);
        if (!email) {
            return;
        }

        copyEmailAndReport($element, email);
    };

    hydrateEmailSpans();
});

